import * as df from 'date-fns';

export const isPast = date => df.differenceInCalendarDays(makeDate(date), new Date()) < 0;

export const makeDate = d => {
    return typeof d === 'string' ? df.parseISO(d) : d;
};

export const addDays = (date, days) => {
    return df.addDays(makeDate(date), days);
};

export const addSeconds = (date, secs) => {
    return df.addSeconds(makeDate(date), secs);
};

export const addMinutes = (date, mins) => {
    return df.addMinutes(makeDate(date), mins);
};

export const addMonths = (date, mns) => {
    return df.addMonths(makeDate(date), mns);
};

export const addWeeks = (date, wks) => {
    return df.addWeeks(makeDate(date), wks);
};

export const differenceInCalendarDays = (day1, day2) => {
    return df.differenceInCalendarDays(makeDate(day1), makeDate(day2));
};

export const differenceInCalendarMonths = (day1, day2) => {
    return df.differenceInCalendarMonths(makeDate(day1), makeDate(day2));
};

export const differenceInMonths = (day1, day2) => {
    return df.differenceInMonths(makeDate(day1), makeDate(day2));
};

export const endOfDay = date => {
    return df.endOfDay(makeDate(date));
};

export const getDate = date => {
    return df.getDate(makeDate(date));
};

export const getMonth = date => {
    return df.getMonth(makeDate(date));
};

export const getYear = date => {
    return df.getYear(makeDate(date));
};

export const isAfter = (date1, date2) => {
    return df.isAfter(makeDate(date1), makeDate(date2));
};

export const isBefore = (date1, date2) => {
    return df.isBefore(makeDate(date1), makeDate(date2));
};

export const isFuture = date => {
    return df.isFuture(makeDate(date));
};

export const isSameDay = (day1, day2) => {
    return df.isSameDay(makeDate(day1), makeDate(day2));
};

export const isToday = date => {
    return df.isToday(makeDate(date));
};

export const isWithinInterval = (date, start, end) => {
    if (isBefore(end, start)) return false;
    return df.isWithinInterval(makeDate(date), { start: makeDate(start), end: makeDate(end) });
};

export const isYesterday = date => {
    return df.isYesterday(makeDate(date));
};

export const startOfMonth = date => {
    return df.startOfMonth(makeDate(date));
};
export const startOfWeek = date => {
    return df.startOfWeek(makeDate(date));
};

export const startOfToday = () => {
    return df.startOfToday();
};

export const startOfYesterday = () => {
    return df.startOfYesterday();
};

export const startOfYear = date => {
    return df.startOfYear(makeDate(date));
};

export const IsSameDateIgnoreTimeAndTimeZone = (day, month, year) => {
    if (day === undefined || month === undefined || year === undefined) {
        return false;
    }

    const comparisonDate = new Date();
    comparisonDate.setTime(comparisonDate.getTime() + comparisonDate.getTimezoneOffset() * 60 * 1000);

    //js dates have a zero based month
    return (
        day === comparisonDate.getDate() && month === comparisonDate.getMonth() + 1 && year === comparisonDate.getFullYear()
    );
};

export const IsBeforeOrSameDateIgnoreTimeAndTimeZone = (earlierDate, laterDate) => {
    if (earlierDate === undefined || laterDate === undefined) {
        return false;
    }

    earlierDate = makeDate(earlierDate);
    const earliestDay = earlierDate.getDate();
    const earliestMonth = earlierDate.getMonth() + 1; // adjust the zero based month
    const earliestYear = earlierDate.getFullYear();

    const laterDateParts = laterDate.split('-'); // the later date is in the format yyyy-mm-dd, more tests needed to get the parts

    const laterDay = parseInt(laterDateParts[2], 10);
    const laterMonth = parseInt(laterDateParts[1], 10);
    const laterYear = parseInt(laterDateParts[0], 10);

    return (
        earliestYear < laterYear ||
        (earliestYear === laterYear && earliestMonth < laterMonth) ||
        (earliestYear === laterYear && earliestMonth === laterMonth && earliestDay <= laterDay)
    );
};

export const e4Formats = {
    default: 'do MMM yyyy',
    monthShort: 'MMM yy',
    monthVeryShort: 'MMM',
    month: 'MMMM yy',
    monthLong: 'MMMM yyyy',
    monthName: 'MMMM',
    long: 'do MMMM yyyy',
    longWithDay: 'EEEE do MMMM yyyy',
    urlSafe: 'yyyy-MM-dd',
    time: 'HH:mm',
    recent: 'EEE do MMMM',
    week: 'do MMM',
};

export const e4Format = (d, type, time, nullValue) => {
    if ((d === null || d === undefined) && nullValue !== undefined) {
        return nullValue;
    }
    type = type || e4Formats.default;
    const f = `${type}${time ? ` @ ${e4Formats.time}` : ''}`;
    return df.format(makeDate(d || '2023-01-01'), f);
};
